import { useContext } from "react"
import { CheckoutScreenContext } from "../contexts/checkoutScreenContext"
import { CheckoutScreenContextType } from "../types/checkoutScreenContextTypes"

export const useCheckoutScreenContext = () => {
  const context = useContext(CheckoutScreenContext) as CheckoutScreenContextType
  return context;
}
